import React, { useEffect, useState } from 'react';

import { ReactComponent as ChevronDownIcon } from '../../../assets/icons/chevron-down-black.svg';
import { capitalize, toTitleCase } from '../../../shared/utils/utils';
import { GenericObject, GenericVoidFunction } from '../../types/genericTypes';
import StyledMenu, { IMenuItem, IMenuPosition } from '../StyledMenu/StyledMenu';

import './styles.scss';

type TextTransformationsTypes = 'uppercase' | 'capitalize' | 'titlecase';

type TextTransformations = {
  [key in TextTransformationsTypes]: (label: string) => string;
};

const textTransformations: TextTransformations = {
  uppercase: (label: string) => label.toUpperCase(),
  capitalize: (label: string) => capitalize(label),
  titlecase: (label: string) => toTitleCase(label)
};

interface DropdownButtonProps {
  itemList: GenericObject[];
  currentItem: GenericObject;
  setCurrentItem: GenericVoidFunction;
  menuDirection?: {
    anchor: IMenuPosition;
    transform: IMenuPosition;
  };
  disabled?: boolean;
  textTransform?: TextTransformationsTypes;
}

const DropdownButton = ({
  currentItem,
  itemList,
  menuDirection,
  setCurrentItem,
  disabled,
  textTransform = 'uppercase'
}: DropdownButtonProps) => {
  const [menuList, setMenuList] = useState<IMenuItem[]>([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleButtonClick = async (event: any) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const transformLabel = (label: string) => {
    return textTransformations[textTransform](label);
  };

  useEffect(() => {
    if (itemList.length > 0) {
      const menuItems = itemList.map((item) => ({
        label: transformLabel(item.name),
        action: () => {
          setCurrentItem(item);
          handleClose();
        }
      }));
      setMenuList(menuItems);
    }
  }, [itemList]);

  return (
    <>
      <div
        className={disabled ? 'dropdown-btn-container disabled' : 'dropdown-btn-container'}
        onClick={handleButtonClick}
      >
        <div className="dropdown-btn-content">{transformLabel(currentItem.name)}</div>
        {!disabled && <ChevronDownIcon className="arrow-icon" data-testid="chevron-down-icon" />}
      </div>
      {!disabled && (
        <StyledMenu
          anchorEl={anchorEl}
          handleClose={handleClose}
          menuItems={menuList}
          anchorOrigin={menuDirection?.anchor}
          transformOrigin={menuDirection?.transform}
        />
      )}
    </>
  );
};

export default DropdownButton;
